module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/.pnpm/babel-loader@8.0.4_@babel+core@7.6.4_webpack@4.41.0/node_modules/babel-loader/lib/index.js??ref--4-0!./index.js"));
	});
}